import React, { useState, useContext } from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import { SecondaryButton } from '../../../../Core/FormInput';
import { InputLabel, Typography } from '@material-ui/core';
import { FormHelperText } from '@material-ui/core';
// import { useToast } from '../../../../../Core/Hooks/useToast';
// import { DataGrid } from '../../../../../Core/Controls';
import { Backup } from '@material-ui/icons';
import { postImportBudget } from '../../../../Core/Service/ManageAccount/NominalBudget-Modal-Service.js';
import AppContext from '../../../../App/AppContext.js';

const ImportBudget = (props) => {
    const [state, setState] = useState({
        errors: {},
        file: '',
        rows: [],
        showTable: false
    });

    // const { showToastSuccess, showToastError } = useToast();
    const [btnLoader, setBtnLoader] = useState(false);
    const { showToast } = useContext(AppContext);

    const onFileSelect = (e) => {
        const { files } = e.target;
        if (files.length) {
            setState((st) => ({ ...st, fileName: files[0].name, selectedFile: files[0] }));
        }
    };

    const handleSubmit = async () => {
        if (state.fileName && state.selectedFile) {
            setBtnLoader(true);
            setState((st) => ({ ...st, uploading: true }));
            const data = new FormData();
            data.append(state.fileName, state.selectedFile);
            let res = await postImportBudget(data);
            if (res.success) {
                showToast(res.data.message);
                props.onSubmit();
                setBtnLoader(false);
            } else {
                showToast(res.message);
                setBtnLoader(false);
            }
        }
    };

    return (
        <Grid container spacing={2} className="screen mt_10">
            <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item>
                        <InputLabel required>Upload file</InputLabel>
                    </Grid>
                    <Grid item>
                        <Tooltip title="Upload Document">
                            <label>
                                <Backup color="secondary" style={{ cursor: 'pointer' }} />
                                <input multiple type="file" onChange={onFileSelect} style={{ display: 'none' }} accept=".xlsx, .xls, .csv" />
                            </label>
                        </Tooltip>
                        <FormHelperText error>{state.errors.file}</FormHelperText>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6} md={4} lg={2}>
                            <SecondaryButton disabled={!state.selectedFile} isBtnLoader={btnLoader} onClick={handleSubmit} fullWidth className="submit_btn">
                                Import Budget
                            </SecondaryButton>
                        </Grid>
                        <Grid item xs={6} md={4} lg={2}>
                            <SecondaryButton onClick={props.onClose} fullWidth className="submit_btn">
                                Cancel
                            </SecondaryButton>
                        </Grid>
                    </Grid>
                </Typography>
            </Grid>
        </Grid>
    );
};

export default ImportBudget;
